<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";

export default {
  data() {
    return {
      vueAppClasses: [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className == "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className == "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  },
  created() {
    this.$store.dispatch("initAuth");
    let dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    const data = [];
    data["servisAdresi"] = localStorage.getItem("servisAdresi");
    data["id"] = localStorage.getItem("id");
    data["musteriId"] = localStorage.getItem("musteriId");
    data["adSoyad"] = localStorage.getItem("adSoyad");
    data["firmaAdi"] = localStorage.getItem("firmaAdi");
    data["plasiyer"] = localStorage.getItem("plasiyer");
    data["printAddress"] = localStorage.getItem("printAddress");
    data["printAddress2"] = localStorage.getItem("printAddress2");
    data["grupKod"] = localStorage.getItem("grupKod");
    data["yetkiTipi"] = localStorage.getItem("yetkiTipi");
    data["tokenId"] = localStorage.getItem("tokenId");
    data["ekYetkiler"] = localStorage.getItem("ekYetkiler");
    data["ekAlan1"] = localStorage.getItem("ekAlan1");
    data["sube"] = localStorage.getItem("sube");
    data["moduller"] = localStorage.getItem("moduller");
    data["crmCustomerCode"] = localStorage.getItem("crmCustomerCode");
    data["crmApi"] = localStorage.getItem("crmApi");

    localStorage.setItem("servisAdresi", data["servisAdresi"]);
    localStorage.setItem("id", localStorage.getItem("id"));
    localStorage.setItem("musteriId", localStorage.getItem("musteriId"));
    localStorage.setItem("adSoyad", localStorage.getItem("adSoyad"));
    localStorage.setItem("firmaAdi", localStorage.getItem("firmaAdi"));
    localStorage.setItem("plasiyer", localStorage.getItem("plasiyer"));
    localStorage.setItem("printAddress", localStorage.getItem("printAddress"));
    localStorage.setItem("printAddress2", localStorage.getItem("printAddress2"));
    localStorage.setItem("grupKod", localStorage.getItem("grupKod"));
    localStorage.setItem("yetkiTipi", localStorage.getItem("yetkiTipi"));
    localStorage.setItem("tokenId", localStorage.getItem("tokenId"));
    localStorage.setItem("ekYetkiler", localStorage.getItem("ekYetkiler"));
    localStorage.setItem("ekAlan1", localStorage.getItem("ekAlan1"));
    localStorage.setItem("sube", localStorage.getItem("sube"));
    localStorage.setItem("moduller", localStorage.getItem("moduller"));
    localStorage.setItem("crmCustomerCode", localStorage.getItem("crmCustomerCode"));
    localStorage.setItem("crmApi", localStorage.getItem("crmApi"));
    console.log(localStorage.getItem("crmApi"));
    this.$store.commit("setToken", data);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
[dir] .main-horizontal.navbar-floating .router-content {
  margin-top: 125px !important;
}
</style>
